import { render, staticRenderFns } from "./NewApplications.vue?vue&type=template&id=95397944"
import script from "./NewApplications.vue?vue&type=script&lang=js"
export * from "./NewApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports